/*
 * PublicTestimonialsPage.jsx
 *
 * Public /testimonios page — same CommentsSection as the home, but standalone
 * (no login gate, no PWA gate). Includes back-links to /servicios and /.
 */

import { Link } from "react-router-dom";
import { ArrowLeft, Home, Sparkles } from "lucide-react";
import { CommentsSection } from "@/components/CommentsSection";
import { LanguageProvider } from "@/contexts/LanguageContext";

export default function PublicTestimonialsPage() {
  return (
    <LanguageProvider>
      <div className="min-h-screen bg-gradient-to-b from-[#08040d] via-[#0a0510] to-black text-neutral-100" data-testid="public-testimonials-page">
        {/* Nav */}
        <nav className="sticky top-0 z-40 bg-black/70 backdrop-blur-md border-b border-white/5">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
            <Link
              to="/servicios"
              data-testid="testimonials-back-services"
              className="inline-flex items-center gap-1.5 text-[11px] uppercase tracking-widest text-neutral-300 hover:text-[#d4af37]"
            >
              <ArrowLeft className="w-3.5 h-3.5" /> Servicios
            </Link>
            <div className="inline-flex items-center gap-1.5 text-[#d4af37] text-[11px] uppercase tracking-widest">
              <Sparkles className="w-3.5 h-3.5" /> Testimonios reales
            </div>
            <Link
              to="/"
              data-testid="testimonials-home"
              className="inline-flex items-center gap-1.5 text-[11px] uppercase tracking-widest text-neutral-300 hover:text-[#d4af37]"
            >
              <Home className="w-3.5 h-3.5" /> Inicio
            </Link>
          </div>
        </nav>

        <CommentsSection />
      </div>
    </LanguageProvider>
  );
}
